import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

function Celda(props) {
   const {valor, nombreCampo, titulo, children, ...other} = props;

   return (
      <Grid item {...other}>
         <Typography
            variant="h6"
            className="MuiTableHead-root"
            display="inline"
         >{`${titulo}:`}</Typography>{' '}
         <Typography variant="body1" display="inline">
            {children}
         </Typography>
      </Grid>
   );
}

export default Celda;
